import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-post-description',
  imports: [],
  templateUrl: './post-description.component.html',
  styleUrl: './post-description.component.scss'
})
export class PostDescriptionComponent {
  readonly dialogRef = inject(MatDialogRef<PostDescriptionComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  text:string=''

  constructor(
    private router: Router,
  ) { 
    this.text = this.data.text
    this.router.events.subscribe(()=>{
			this.onNoClick()
		})
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.text=''
  }
}
